import {
  DiagramNodeIconShape,
  GraphVizIconShape,
  GraphVizNodeComponentType,
  GraphVizTileEmphasis,
} from '@/components/diagrams/diagramStyle';
import { RadioGroupOption } from '@/components/form/baseInputs/inputTypes';

export { GraphVizIconShape, GraphVizNodeComponentType, GraphVizTileEmphasis };

export const GraphVizNodeComponentTypeOptions: RadioGroupOption<GraphVizNodeComponentType>[] =
  [
    { label: 'Tile', value: GraphVizNodeComponentType.Tile },
    { label: 'Icon', value: GraphVizNodeComponentType.TileIcon },
  ];

// Stored `iconShape` values use the shared vocabulary, which has no rounded shape.
const VALID_ICON_SHAPES = new Set<string>(Object.values(DiagramNodeIconShape));

/**
 * Parses an unknown string into a GraphVizIconShape, returning undefined
 * for null/unrecognized values. Case-insensitive.
 */
export function parseIconShape(
  value?: string | null
): GraphVizIconShape | undefined {
  if (!value) return undefined;
  const upper = value.toUpperCase();
  return VALID_ICON_SHAPES.has(upper)
    ? (upper as GraphVizIconShape)
    : undefined;
}

const VALID_TILE_EMPHASES = new Set<string>(
  Object.values(GraphVizTileEmphasis)
);

/**
 * Parses an unknown string into a GraphVizTileEmphasis, returning undefined
 * for null/unrecognized values. Case-insensitive.
 */
export function parseTileEmphasis(
  value?: string | null
): GraphVizTileEmphasis | undefined {
  if (!value) return undefined;
  const upper = value.toUpperCase();
  return VALID_TILE_EMPHASES.has(upper)
    ? (upper as GraphVizTileEmphasis)
    : undefined;
}
